import script from "./EstateCardFull.vue?vue&type=script&setup=true&lang=js"
export * from "./EstateCardFull.vue?vue&type=script&setup=true&lang=js"

import "./EstateCardFull.vue?vue&type=style&index=0&id=4fc3ea6f&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fc3ea6f"]])

export default __exports__